import * as types from './mutation-types';
import API from '@/services/commonApi';
import { GETBROKERFAVOURITES, GETBUILDERS, BROKERFAVOURITES, BROKERACCOUNT, BROKERCUSTOMERS, BROKERPROJECTS, LIVEPROJECTS, BROKERADDCUSTOMERS, BROKERADDEDCUSTOMERS, BROKERCUSTOMERBID, BROKERSITEVISIT, BROKEREDITCUSTOMERS } from '@/utils/endpoint';

const actions = {
  getFavProjects: ({ commit }) => {
    API.get(GETBROKERFAVOURITES)
      .then((response) => {
        commit(types.FAVOURITES, response);
      })
      .catch((error) => {
        console.log(error);
      });
  },
  getMyCustomers: ({ commit }) => {
    API.get(BROKERCUSTOMERS)
      .then((response) => {
        commit(types.MYCUSTOMERS, response);
      })
      .catch((error) => {
        console.log(error);
      });
  },
  getMyProjects: ({ commit }, payload) => {
    API.get(BROKERPROJECTS)
      .then((response) => {
        commit(types.MYPROJECTS, response);
        if (payload && payload.cb_success)
          payload.cb_success(response);
      })
      .catch((error) => {
        console.log(error);
      });
  },
  getLiveProjects: ({ commit }, payload) => {
    API.get(LIVEPROJECTS)
      .then((response) => {
        commit(types.LIVEPROJECTS, response);
        if (payload && payload.cb_success)
          payload.cb_success(response);
      })
      .catch((error) => {
        console.log(error);
      });
  },
  getMyFavourites: ({ commit }) => {
    API.get(BROKERFAVOURITES)
      .then((response) => {
        commit(types.MYFAVOURITES, response);
      })
      .catch((error) => {
        console.log(error);
      });
  },
  setCustomerAccessToken: ({ commit }, token) => {
    commit(types.CUSTOMERTOKEN, token);
  },
  removeCustomerAccessToken: ({ commit }) => {
    commit(types.CUSTOMERTOKEN, '');
  },
  addCustomer: ({ _commit }, payload) => {
    API.post(BROKERACCOUNT, payload.user)
      .then((response) => {
        payload.cb(response);
      })
      .catch((error) => {
        console.log(error);
      });
  },
  editCustomer: ({ _commit }, payload) => {
    API.put(BROKERACCOUNT, payload.user)
      .then((response) => {
        payload.cb(response);
      })
      .catch((error) => {
        console.log(error);
      });
  },
  removeCustomer: ({ _commit }, payload) => {
    API.delete(BROKERACCOUNT, payload.customerID)
      .then(() => {
        payload.cb();
      })
      .catch((error) => {
        console.log(error);
      });
  },
  getBuilders: ({ commit }) => {
    API.get(GETBUILDERS)
      .then((response) => {
        commit(types.BUILDERS, response);
      })
      .catch((error) => {
        console.log(error);
      });
  },
  addBrokerCustomer: ({ _commit }, payload) => {
    API.post(BROKERADDCUSTOMERS, payload.data)
      .then((response) => {
        if (payload.cb_success)
          payload.cb_success(response);
      })
      .catch((error) => {
        if (payload.cb_error)
          payload.cb_error(error);
      });
  },
  getAddedCustomers: ({ commit }, payload) => {
    API.get(BROKERADDEDCUSTOMERS)
      .then((response) => {
        commit(types.MYADDEDCUSTOMERS, response);
        if (payload && payload.cb_success)
          payload.cb_success();
      })
      .catch((error) => {
        console.log(error);
        if (payload.cb_error)
          payload.cb_error(error);
      });
  },
  editAddedCustomer: ({ dispatch }, payload) => {
    API.put(BROKEREDITCUSTOMERS, payload)
      .then(() => {
        dispatch('getAddedCustomers');
        if (payload.cb_success)
          payload.cb_success();
      })
      .catch((error) => {
        if (payload.cb_error)
          payload.cb_error(error);
        console.log(error);
      });
  },
  placeCustomerBid: ({ _commit }, payload) => {
    API.post(BROKERCUSTOMERBID, payload.data)
      .then(() => {
        if (payload.cb_success)
          payload.cb_success();
      })
      .catch((error) => {
        if (payload.cb_error)
          payload.cb_error(error);
      });
  },
  addSiteVisit: ({ _commit }, payload) => {
    API.post(BROKERSITEVISIT, payload.data)
      .then((response) => {
        payload.cb_success(response);
      })
      .catch((error) => {
        payload.cb_error(error);
        console.log(error);
      });
  },
  editSiteVisit: ({ _commit }, payload) => {
    API.put(`${BROKERSITEVISIT}${payload.data.id}/`, payload.data)
      .then(() => {
        payload.cb_success();
      })
      .catch((error) => {
        payload.cb_error(error);
        console.log(error);
      });
  },
  resetToDefaultState: ({ commit }) => {
    commit(types.RESET);
  },
};

export default actions;



// WEBPACK FOOTER //
// ./src/store/modules/broker/actions.js